<template>
<vs-alert color="danger" title="No posee asesor" v-if="assignedAdvisor == null">
    <span>No tiene asignado un asesor en nuestra plataforma.</span>
    <br>
    <span>La asignación de asesor sucede a partir de que usted contrate alguno de nuestros planes.</span>
</vs-alert>
<vx-card class="max-w-10 p-2" v-else>
    <vs-avatar class="mx-auto block" size="120px" :src="getAdvisorImage(assignedAdvisor.thumbnail_employee)" />
    <div class="text-center p-6">
        <h4>{{assignedAdvisor.name_employee}} {{assignedAdvisor.surname_employee}}</h4>
        <div class="text-purple">Asesor</div>
        <div class="text-gray">{{assignedAdvisor.corporate_email_employee}}</div>
        <div class="text-gray">{{assignedAdvisor.corporate_mobile_phone_employee}}</div>
    </div>
    <div class="flex flex-wrap">
        <!-- <vs-button class="mt-4 mr-2 shadow-lg w-full" type="gradient" color="danger">WhatsApp</vs-button> -->
        <!-- <vs-button icon="icon-message-circle" size="large" icon-pack="feather" class="bg-success-gradient" color="success" type="filled" target href="https://wa.me/34659523938">WhatsApp</vs-button> -->
    </div>
    <div class="vx-col block mx-auto self-center">
        <img src="@/assets/images/pages/somos-cohen-y-aguirre.png" alt="somos-cohen-y-aguirre" class="mx-auto w-full">
    </div>
</vx-card>
</template>
<script>
import axios from '@/axios.js'
export default {
  data () {
    return {
      userInfo: null, 
      id_client: null
    }
  },
  methods: {
    getAdvisorImage (thumbnail_employee) {
      if (thumbnail_employee === null) return
      return (axios.defaults.baseURLnoAPI) + thumbnail_employee
    }
  }, 
  computed: {
    assignedAdvisor () {
      return this.$store.state.assignedAdvisor
    }
  },
  created () {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo')) || this.$store.state.AppActiveUser
    this.id_client = this.userInfo.client_id
    const obj = {
      client_id: this.userInfo.client_id
    } 
    this.$vs.loading()
    this.$store.dispatch('fetchMyAdvisor', obj)
      .then(() => { this.$vs.loading.close() })
      .catch(err => { 
        this.$vs.loading.close()
        // console.log(Object.getOwnPropertyNames(err))
        console.error(err)
        // console.log(err.response.data.errors)
        if (typeof err.response.data.errors === 'string') {
          this.$vs.notify({
            title: 'Error',
            text: `${err.response.data.errors}`,
            color: 'warning',
            iconPack: 'feather',
            icon:'icon-x-circle',
            time: 6000
          })
        } else {
          const array_errors = Object.entries(err.response.data.errors)
          for (let i = 0; i < array_errors.length; i++) {
            this.$vs.notify({
              title: 'Error',
              text: `${array_errors[i][1][0]}`,
              iconPack: 'feather',
              icon: 'icon-x-circle',
              color: 'warning',
              time: 6000
            })
          }
        }
      })
  }
}
</script>

<style scoped>
.text-purple {
    color: #9561e2;
}
</style>